/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo } from "react";

import { onUserStateChanged } from "../services/firebase";

const AuthContext = React.createContext();

function AuthProvider(props) {
  const [user, setUser] = React.useState(undefined);

  useEffect(() => {
    const unsubscribe = onUserStateChanged(setUser);
    return () => {
      unsubscribe();
    };
  }, []);

  const value = useMemo(() => ({ user }), [user]); // TODO: need to test

  return <AuthContext.Provider value={value} {...props} />;
}

export { AuthContext, AuthProvider };
